import Sortable from "sortablejs/modular/sortable.core.esm.js"

import * as $ from "jquery"

export default function triggerFieldsSortable(updateUrl) {
  const _url = updateUrl

  function reorderTriggerFields() {
    let triggerFieldIds = ""

    $.each($(".field-list li"), function () {
      triggerFieldIds =
        triggerFieldIds + "&item_ids[]=" + $(this).data("trigger-field-id")
    })
    $.ajax({
      url: _url,
      data:
        triggerFieldIds +
        "&authenticity_token=" +
        encodeURIComponent(window.App.authenticityToken),
      type: "POST",
      success() {
        App.Scripts.partners.displayFlash("Trigger fields reordered")
      },
      error() {
        App.Scripts.partners.displayFlash(
          "There has been an error reordering the trigger fields, try again!",
          "error"
        )
      },
    })
  }

  const inputsEl = document.getElementById("input-list")
  return Sortable.create(inputsEl, {
    animation: 150,
    onUpdate: reorderTriggerFields,
  })
}
